module.exports = __webpack_public_path__ + "static/media/cl_2.121ea426.jpg";